import { api } from '@/lib/api'

export type McpToken = {
  id: string
  label: string
  created_at: string
  last_used_at: string | null
  profile: string
}

/** The plaintext token is returned ONLY at mint time (server stores just its hash). */
export type MintedMcpToken = { id: string; label: string; token: string; profile: string }

export function fetchMcpTokens(): Promise<McpToken[]> {
  return api<McpToken[]>('/mcp-tokens')
}

export function mintMcpToken(label: string, profile = 'full'): Promise<MintedMcpToken> {
  return api<MintedMcpToken>('/mcp-tokens', {
    method: 'POST',
    body: JSON.stringify({ label, profile }),
  })
}

export function revokeMcpToken(id: string): Promise<void> {
  return api(`/mcp-tokens/${id}`, { method: 'DELETE' })
}
